module.exports = __webpack_public_path__ + "img/baleno-glx.a2956dd4.png";